import SEO from "../components/SEO";
import { Reveal, Eyebrow } from "../components/Reveal";
import EnquiryForm from "../components/EnquiryForm";

export default function Catalogue() {
  return (
    <div data-testid="catalogue-page" className="pt-28 sm:pt-36">
      <SEO title="Request Catalogue — Ramesh Kapoor and Sons Jewellers"
        description="Request the current wholesale jewellery catalogue from Ramesh Kapoor and Sons Jewellers Pvt. Ltd." />
      <section className="max-w-[900px] mx-auto px-5 sm:px-8 pb-28">
        <Reveal>
          <Eyebrow>For the Trade</Eyebrow>
          <h1 className="font-serif font-light text-4xl sm:text-6xl tracking-tight text-[#FBF9F5] mt-4">
            Request the <span className="italic text-[#C5A059]">Catalogue</span>
          </h1>
          <p className="text-base text-[#94A3B8] leading-loose mt-6 max-w-2xl">
            The current wholesale catalogue with product codes, weight ranges, and purity details is shared
            directly with jewellers and retailers.
          </p>
        </Reveal>
        <Reveal delay={0.1} className="mt-12 border border-white/10 bg-[#0B1320] p-8 sm:p-12">
          <EnquiryForm
            type="catalogue_request"
            fields={[
              { name: "business_name", label: "Business name", required: true },
              { name: "city", label: "City", required: true },
              { name: "categories", label: "Categories of interest", placeholder: "e.g. chains, bridal sets, coins" },
              { name: "office", label: "Preferred office", type: "select", options: ["Sarafa Bazar, Meerut", "Karol Bagh, Delhi", "Either"] },
            ]}
          />
        </Reveal>
      </section>
    </div>
  );
}
